import React, { ReactNode } from "react";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiRequest } from "../Auth/AuthConfig.tsx";

interface AuthenticatedRouteProps {
  children: ReactNode; // Explicitly type the children prop
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={apiRequest}>
      {children}
    </MsalAuthenticationTemplate>
  );
};

export default AuthenticatedRoute;
